(function() {
  const productData = window.__productVariants;
  if (!productData) return;

  const variantSelects = document.querySelector('variant-selects');
  if (!variantSelects) return;
  variantSelects.style.display = 'none';

  const dimensions = [
    { key: 'condition', label: 'Condition' },
    { key: 'ram', label: 'RAM' },
    { key: 'storage', label: 'Storage' },
    { key: 'keyboard', label: 'Keyboard layout' },
    { key: 'battery', label: 'Battery health' },
    { key: 'power_adapter', label: 'Power adapter' }
  ];

  let selected = {};

  function getCompatibleVariants(excludeKey) {
    return productData.variants.filter(v =>
      dimensions.every(d => {
        if (d.key === excludeKey) return true;
        if (!selected[d.key]) return true;
        return v.metafields?.[d.key] === selected[d.key];
      })
    );
  }

  function findVariant() {
    return productData.variants.find(v =>
      dimensions.every(d => !selected[d.key] || v.metafields?.[d.key] === selected[d.key])
    ) || null;
  }

  function updatePrice(variant) {
    if (!variant) return;
    const priceEl = document.querySelector('.price--large .price-item--regular');
    if (priceEl) {
      priceEl.textContent = new Intl.NumberFormat('da-DK', {
        style: 'currency', currency: 'DKK'
      }).format(variant.price / 100);
    }
  }

  function updateSpecs(variant) {
  if (!variant) return;
  const m = variant.metafields || {};

  // Opdater specs-grid tiles
  const specMap = {
  '.spec-val-memory': m.ram,
  '.spec-val-storage': m.storage,
  '.spec-val-cpu': m.cpu,
};
  Object.entries(specMap).forEach(([sel, val]) => {
    const el = document.querySelector(sel);
    if (el && val) el.textContent = val;
  });

  // Opdater condition badge
  const conditionBadge = document.querySelector('.spec-val-condition');
  if (conditionBadge && m.condition) {
    conditionBadge.textContent = '✓ ' + m.condition;
  }
}

  function updateVariantInput(variant) {
    if (!variant) return;
    const input = document.querySelector('[name="id"]');
    if (input) {
      input.value = variant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    }
    const selectedVariantScript = document.querySelector('[data-selected-variant]');
    if (selectedVariantScript) {
      selectedVariantScript.textContent = JSON.stringify({ id: variant.id });
    }
  }

 function updateAvailability(variant) {
  const addToCart = document.querySelector('.product-form__submit');
  if (addToCart) {
    addToCart.disabled = !variant || !variant.available;
    addToCart.querySelector('span')
      ? addToCart.querySelector('span').textContent = (!variant || !variant.available) ? 'Udsolgt' : 'Læg i indkøbskurv'
      : addToCart.textContent = (!variant || !variant.available) ? 'Udsolgt' : 'Læg i indkøbskurv';
  }
}

  function render() {
    // Nulstil inventory element
    const inventoryEl = document.querySelector('[id^="Inventory-"]');
    if (inventoryEl) inventoryEl.textContent = '';

    const existing = document.querySelector('#custom-variant-picker');
    if (existing) existing.remove();

    const wrapper = document.createElement('div');
    wrapper.id = 'custom-variant-picker';

    dimensions.forEach(d => {
      // Alle mulige værdier for denne dimension
      const allValues = [...new Set(
        productData.variants.map(v => v.metafields?.[d.key]).filter(Boolean)
      )];
      if (allValues.length === 0) return;

      // Kompatible værdier baseret på andre valgte dimensioner
      const compatibleVariants = getCompatibleVariants(d.key);
      const compatibleValues = new Set(
        compatibleVariants.map(v => v.metafields?.[d.key]).filter(Boolean)
      );

      const group = document.createElement('div');
      group.className = 'custom-picker-group';

      const label = document.createElement('div');
      label.className = 'custom-picker-label';
      label.textContent = d.label;
      group.appendChild(label);

      const btns = document.createElement('div');
      btns.className = 'custom-picker-buttons';

      allValues.forEach(val => {
        const btn = document.createElement('button');
        btn.type = 'button';
        btn.textContent = val;
        btn.className = 'custom-picker-btn';

        if (selected[d.key] === val) btn.classList.add('active');

        // Gråer knappen ud hvis den ikke er kompatibel
        if (!compatibleValues.has(val)) {
          btn.classList.add('disabled');
          btn.disabled = true;
        }

        btn.addEventListener('click', () => {
          // Toggle valg
          selected[d.key] = selected[d.key] === val ? null : val;
          const variant = findVariant();
          render();
          updatePrice(variant);
          updateSpecs(variant);
          updateVariantInput(variant);
          updateAvailability(variant);
        });

        btns.appendChild(btn);
      });

      group.appendChild(btns);
      wrapper.appendChild(group);
    });

    variantSelects.insertAdjacentElement('afterend', wrapper);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', render);
  } else {
    render();
  }
})();